import createIcon from '../../createIcon';

/**
 * @component @name RollerShadesClosed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTguMTI1VjIuMTI1SDRWMTguMTI1SDJWMjAuMTI1SDEwLjI1QzEwLjI1IDIxLjA5NSAxMS4wMyAyMS44NzUgMTIgMjEuODc1QzEyLjk3IDIxLjg3NSAxMy43NSAyMS4wOTUgMTMuNzUgMjAuMTI1SDIyVjE4LjEyNUgyMFpNNiAxOC4xMjVWMTYuMTI1SDExVjE4LjEyNUg2Wk0xMyAxOC4xMjVWMTYuMTI1SDE4VjE4LjEyNUgxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RollerShadesClosed = createIcon('RollerShadesClosed', [
  [
    'path',
    {
      d: 'M20 18.125V2.125H4V18.125H2V20.125H10.25C10.25 21.095 11.03 21.875 12 21.875C12.97 21.875 13.75 21.095 13.75 20.125H22V18.125H20ZM6 18.125V16.125H11V18.125H6ZM13 18.125V16.125H18V18.125H13Z',
      key: '4z326t',
    },
  ],
]);

export default RollerShadesClosed;
